













































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ

import router from '@/router';

@Component
export default class CEFoundationMenu extends Vue {

}
